import FamilyDiscountSettings from '../../components/settings/FamilyDiscountSettings';

export default FamilyDiscountSettings;
